module.exports = __webpack_public_path__ + "static/media/rectangle-16.f6aefae6.svg";